import { render, staticRenderFns } from "./formCatatanDalamPenilaian.vue?vue&type=template&id=d9608116&"
import script from "./formCatatanDalamPenilaian.vue?vue&type=script&lang=js&"
export * from "./formCatatanDalamPenilaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports